<div class="d-flex popup-container">
  <div class="column right-column">
    <h4 class="mb-3">Email successfully generated</h4>

    <p>
      We generated disposable email for your next Quidco purchases. Disposable
      email will forward cashback confirmation to your private email.
    </p>

    <div class="p-3 rounded bg-info2 d-flex flex-row align-items-center gap-3 mb-3">
      <i class="bi bi-exclamation-triangle fs-3 text-primary"></i>
      <span>Make sure you <b>copy, save and use</b> that email by every cashback purchase. We sent it also to your email address.</span>
    </div>

    <div class="mb-3">
      <label for="email">Generated email address</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="email"
          [(ngModel)]="email"
          readonly />
        <button
          class="btn btn-outline-secondary"
          type="button"
          (click)="handleCopy()"><i class="bi bi-copy"></i>
        </button>
      </div>
    </div>

    <div>
      <a href="javascript:"><small>How can I manage my emails?</small></a>
    </div>

    <div class="d-flex justify-content-end">
      <button class="btn btn-primary">Close</button>
    </div>

    <app-buttom-logo></app-buttom-logo>
  </div>
</div>
